<template>
  <Modal title="Assign owner" :max-width="400" @close="$emit('close')">
    <div class="assignOwnerBody">
      <p class="assignOwnerIntro">
        Select an owner for {{ selectedCount }} candidate{{ selectedCount !== 1 ? 's' : '' }}.
        Candidates already enrolled in a sequence will be skipped.
      </p>
      <select v-model="userId" class="assignOwnerSelect">
        <option value="" disabled>Select a team member…</option>
        <option v-for="u in userOptions" :key="u.value" :value="u.value">{{ u.label }}</option>
      </select>
    </div>
    <template #footer>
      <button class="btn secondary" @click="$emit('close')">Cancel</button>
      <button class="btn primary" :disabled="!userId || busy" @click="$emit('confirm', userId)">
        {{ busy ? 'Assigning…' : 'Assign' }}
      </button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Modal from './Modal.vue'

defineProps<{
  selectedCount: number
  userOptions: { value: string; label: string }[]
  busy: boolean
}>()

defineEmits<{
  close: []
  confirm: [userId: string]
}>()

const userId = ref('')
</script>

<style scoped>
.assignOwnerBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}
.assignOwnerIntro {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-secondary);
  line-height: var(--lh-normal);
}
.assignOwnerSelect {
  width: 100%;
  padding: var(--space-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-primary);
  background: var(--color-bg-surface);
}
</style>
